module.exports = __webpack_public_path__ + "static/wages_02@2x-f8f2815069ee6fa48d12422a6efd7e76.png";